import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { resolveCanonicalAdminUrl } from '@kawai/shared';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import { AuthProvider } from './lib/auth.js';
// S-137: v2 の書体（Noto Sans JP）を同梱する。CSS の @import だと Tailwind v4 がインライン化して
// woff2 の URL が解決されないため main.tsx で import する（packages/ui/README.md）。
import '@fontsource-variable/noto-sans-jp';
import './index.css';

// S-137 で Tailwind v4 を導入（preflight は .ui-v2 配下に限定 / src/index.css 参照）。
// 未移行の画面はインライン style から hsl(var(--token)) を参照する v1 のまま。

// QueryClient はモジュールトップで singleton 化（HMR を考慮し React state には載せない）。
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // saas-admin の一覧系は即時再取得が起きすぎないように
      // staleTime を 30 秒に。S-06 以降の mutation 後 invalidate で十分。
      staleTime: 30 * 1000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

function renderApp() {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <App />
        </AuthProvider>
      </QueryClientProvider>
    </StrictMode>,
  );
}

// TP-33: 旧ドメイン（apollostation サブドメイン / *.web.app）で開かれた場合は
// 正規ドメイン（tracepit.jp）へ引っ越す（path / query / hash 維持）。旧ブックマークにも
// same-site 化の恩恵を届け、旧オリジンへのセッション・記録の蓄積を止める。
const canonicalUrl = resolveCanonicalAdminUrl(
  'saas-admin',
  window.location.host,
  import.meta.env.MODE,
);
if (canonicalUrl) {
  window.location.replace(
    canonicalUrl.replace(/\/$/, '') +
      window.location.pathname +
      window.location.search +
      window.location.hash,
  );
} else {
  renderApp();
}
